import React from 'react';
import BaseLayout from 'layouts/shared/BaseLayout';

/**
 * Layout Admin - Usa BaseLayout con configuración específica para admin
 */
export default function Admin(props) {
  return (
    <BaseLayout
      layoutType="admin"
      defaultRoute="/panel"
      logoText="Rely"
      {...props}
    />
  );
}
